
<template>
  <div class="detail_box">
    <!-- <div class="product">
      <p class="com_title"><span class="com_line"></span>申请条件</p>
      <div class="p_con"
           v-html="toLineFeed(content)"></div>
    </div> -->
    <div class="loan"
         v-for="(item,index) in productDetail"
         :key="index">
      <div v-if="item.type==1">
        <p class="com_title"><span class="com_line"></span>{{item.title}}</p>
        <div class="p_con"><span class="circle"></span>{{item.message.join(",")}}</div>
      </div>
      <div v-if="item.type==2">
        <p class="com_title"><span class="com_line"></span>{{item.title}}</p>
        <div v-for="(itm,idx) in item.feesDetails"
             :key="idx">
          <div class="p_con"><span class="circle"></span>{{itm.title}} : {{itm.content}}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    // Head,
  },
  data () {
    return {
      productDetail: [],
      content: `大家好
      审核快，放款快
      是否水电费水电费是
      地方看过的风格`
    }
  },
  mounted () {
    this.productId = this.$route.query.productId;
    this.util.title('产品详情');
    this.toPost();
  },
  methods: {
    toLineFeed (str) {  //让字符串换行  
      return str.replace(/\n|\r\n/g, "<br/>")
    },
    toPost () {
      let param = {
        productId: this.productId
      }
      this.$get('/app/newWeb/v1/product/newInfo', param)
        .then(res => {
          if (res.code == 200) {
            this.productDetail = res.data.thymeleafProductParticularsModel.topDetail;
          }
          else {
            _this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.detail_box {
  background: #f7f7f7;
  padding-bottom: 0.1rem;
  padding-top: 0.15rem;
}

.product,
.loan {
  color: #666;
  font-size: 0.14rem;
  padding: 0.15rem;
  background: #fff;
  margin-bottom: 0.15rem;
}
.com_title {
  font-size: 0.16rem;
  color: #333;
  margin-bottom: 0.15rem;
}
.com_line {
  width: 3px;
  height: 0.12rem;
  background: #5175f1;
  display: inline-block;
  margin-right: 0.05rem;
  position: relative;
  top: -0.01rem;
}
.circle {
  display: inline-block;
  width: 0.03rem;
  height: 0.03rem;
  background: #333;
  border-radius: 50%;
  position: relative;
  top: -0.04rem;
  margin-right: 0.1rem;
}
</style>
